<template class="menu-item-cost">
  <v-menu
    v-model="menu"
    :class="{ 'v-menu__activator--disabled': isLoading }"
    :close-on-content-click="false"
    :open-on-click="false"
    min-width="325"
    offset-y
  >
    <v-btn
      slot="activator"
      :disabled="isLoading"
      flat
      @click="openMenu($event)"
    >
      <span class="toolbar__button-label">
        <span v-if="!isSelected" class="autocomplete__text">
          {{ $t(`Common.by`) | capitalizeFirstLetter }} {{ label | textLowercase }}
        </span>

        <span v-else class="autocomplete__text autocomplete__text--active">
          {{ selectedItem.name | ellipsis(15) }}
        </span>
      </span>

      <v-icon
        v-if="!isSelected"
        class="autocomplete__arrow"
        color="gray-6"
        right
        small
      >
        keyboard_arrow_down
      </v-icon>

      <v-icon
        v-if="isSelected"
        class="autocomplete__arrow"
        data-id="menu-item__clear"
        color="accent"
        right
        small
        @click="() => { updateFilters(null), clearSelectedItem() }"
      >
        close
      </v-icon>
    </v-btn>

    <v-list
      class="py-0"
      two-line
    >
      <v-list-tile>
        <AutoCompleteAsync
          :companyId="companyId"
          :label="placeholder || `${$t(`Common.searchBy`)} ${label}`"
          :profiles="profiles"
          :input="filters[type]"
          :clear="clear"
          @change="updateFilters($event)"
        />
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
import AutoCompleteAsync from './AutoCompleteAsync'
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import { isObject } from 'utils/functions'

export default {
  components: {
    AutoCompleteAsync
  },
  props: {
    type: String,
    companyId: {
      type: Number
    },
    label: {
      type: String,
      required: true
    },
    profiles: {
      type: Array
    },
    placeholder: {
      type: String
    },
    status: {
      type: Number,
      default: STATUS_SUCCESS
    }
  },
  computed: {
    isLoading () {
      return this.status === STATUS_IS_LOADING
    },

    isSuccess () {
      return this.status === STATUS_SUCCESS
    },

    isFailed () {
      return this.status === STATUS_FAILED
    }
  },
  data () {
    return {
      menu: false,
      isSelected: false,
      title: null,
      filters: {},
      selectedItem: null,
      clear: false
    }
  },
  mounted () {
    this.title = this.type
  },
  methods: {
    isValidObject (val) {
      return isObject(val)
    },

    openMenu (e) {
      this.menu = e.target.dataset.id !== 'menu-item__clear'
    },

    clearSelectedItem () {
      this.clear = !this.clear
    },

    updateFilters (val) {
      const value = val && val.email ? val.email : null
      this.isSelected = this.isValidObject(val)
      this.menu = false
      this.selectedItem = val
      this.$emit('change', { [this.type]: value })
    }
  }
}
</script>

<style lang="scss">
.v-menu__activator {
  opacity: 1;
  transition: opacity .26s;
}

.v-menu__activator--disabled .v-menu__activator {
  cursor: not-allowed;
  opacity: 0.7;
}
</style>
